import { render } from "./ReportChartWidget.vue?vue&type=template&id=b2d71d50&scoped=true"
import script from "./ReportChartWidget.vue?vue&type=script&lang=js"
export * from "./ReportChartWidget.vue?vue&type=script&lang=js"

import "./ReportChartWidget.vue?vue&type=style&index=0&id=b2d71d50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d71d50"]])

export default __exports__